import get from 'lodash-es/get'
import * as THREE from 'three'

import { getSelectedObjects } from '../selectedObjects/selectors'

import * as actions from './actions'

import LAYER_KEYS from 'config/layerKeys'
import Util from 'components/DrawingCanvas/lib/util'
import Units from 'components/DrawingCanvas/lib/units'

import { LOAD_FACILITY } from '../objects'
import { TOGGLE_LAYER_VISIBILITY } from '../layers'

export const INITIAL_STATE = {
  isUploading: false,
  didFail: false,
  errorMessage: '',
  didAbort: false,
  isAborting: false,
  percentComplete: 0,
  selectedLayer: {
    level: '',
    type: 'overhead',
    goal: undefined,
    url: '',
  },
  grid: {},
  models: {},
}

export default function(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actions.UPLOAD_OBJ: {
      return {
        ...INITIAL_STATE,
        isUploading: true,
        didAbort: false,
        isAborting: false,
      }
    }
    case actions.UPLOAD_COMPLETE: {
      return {
        ...state,
        isUploading: false,
        didAbort: false,
        isAborting: false,
      }
    }
    case actions.UPLOAD_OBJ_FAILED: {
      const errorMessage = get(action, 'payload.errorMessage')
      return {
        ...state,
        isUploading: false,
        didFail: true,
        didAbort: false,
        isAborting: false,
        errorMessage,
      }
    }
    case actions.ABORT_UPLOAD_OBJ: {
      return {
        ...state,
        isUploading: false,
        didAbort: false,
        isAborting: true,
      }
    }
    case actions.UPLOAD_OBJ_ABORTED: {
      return {
        ...state,
        isUploading: false,
        didAbort: true,
        isAborting: false,
      }
    }
    case actions.CANCEL_JOB: {
      const { type } = action.payload

      return {
        ...state,
        isUploading: false,
        didAbort: false,
        isAborting: true,
      }
    }
    case actions.JOB_CANCELLED: {
      return {
        ...state,
        isUploading: false,
        didAbort: true,
        isAborting: false,
      }
    }
    case actions.NOTIFY_UPLOAD_OBJ_PROGRESS: {
      const percentComplete = get(action, 'payload.percentComplete')
      return {
        ...state,
        percentComplete,
      }
    }
    case actions.SET_CFD_LAYER: {
      return {
        ...state,
        selectedLayer: {
          type: action.payload.type,
          url: action.payload.url,
          level: action.payload.level,
          goal: action.payload.goal,
        },
      }
    }

    case TOGGLE_LAYER_VISIBILITY: {
      if (action.payload.layerKey === LAYER_KEYS.CFD) {
        return {
          ...state,
          grid: {
            ...state.grid,
            updateId: Util.guid(),
          },
        }
      }
      return {
        ...state,
      }
    }
    case actions.UPDATE_CFD: {
      return {
        ...INITIAL_STATE,
      }
    }
    case LOAD_FACILITY: {
      return {
        ...INITIAL_STATE,
      }
    }
    default:
      return state
  }
}
